import { TableContainer, Table as ChakraTable, Thead, Tr, Th, Tbody, Td, HStack, Flex, Box, Text, ButtonGroup, Button, SkeletonText, Skeleton, Tfoot, TableCaption } from "@chakra-ui/react";
import { Functions } from "config";

export default function Table({ columns = [], children, meta, loading = false, size = 'sm', setPage = () => {}, footer = null, tableCaption = null, ...props}){

    if(loading){
        const rows = []
        for(var i=0;i<50;i++){ rows.push(<Tr>{ columns.map(({ title, ...props }) => <Td key={title} {...props}><Skeleton w={`${Functions.rand(50, 150)}px`} h="14px" /></Td>)}</Tr>) }

        return (
        <TableContainer>
            <ChakraTable size={size} {...props}>
                <Thead><Tr>{ columns.map(({ title, ...col }, idx) => <Th key={title ?? idx} children={title} {...col} />)}</Tr></Thead>
                <Tbody>{rows}</Tbody>
            </ChakraTable>
        </TableContainer>
        )
    }

    return(
    <>
    { !!meta && <Paginate meta={meta} setPage={setPage} loading={loading} /> }
    <TableContainer>
        <ChakraTable size={size} {...props}>
            {tableCaption && (
                <TableCaption>{tableCaption}</TableCaption>
            )}
            <Thead><Tr>{ columns.map(({ title, ...col }, idx) => <Th key={title ?? idx} children={title} {...col} />)}</Tr></Thead>
            <Tbody>{ children }</Tbody>
            {footer && <Tfoot>{ footer }</Tfoot>}
        </ChakraTable>
    </TableContainer>
    { !!meta && <Paginate meta={meta} setPage={setPage} loading={loading} /> }
    </>
    )
}

const Paginate = ({ meta, loading, setPage = () => {} }) => {
    return(
    <Flex justifyContent="space-between" py={7}>
        <Box>
            <Text fontSize="sm">Exibindo {meta?.per_page} de {meta.total} resultados | Página {meta?.current_page} de {meta?.last_page}</Text>
        </Box>
        <Box>
            <ButtonGroup size="xs">
                { meta.current_page > 1 && <Button children={`Anterior (${meta.current_page - 1})`} onClick={() => setPage(meta.current_page - 1)} /> }
                { meta.current_page < meta.last_page && <Button children={`Próxima (${meta?.current_page + 1})`} onClick={() => setPage(meta.current_page + 1)} /> }
            </ButtonGroup>
        </Box>
    </Flex>
    )
}
